import styled from "@emotion/styled";
import { fontRobotoCondensed, setLineClamp } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";

export const Container = styled.div`
  padding: 24px;

  border: 1px solid #bbbbbb;
  border-radius: 8px;

  background: #f6f6f6;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 600px;
    margin-inline: auto;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;

  margin-block-end: 16px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;

  font-weight: 700;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
`;

export const ImageIcon = styled(BaseImage)`
  inline-size: 48px;
  block-size: 48px;

  border: 1px solid #bbbbbb;
  border-radius: 50%;

  object-fit: cover;
  object-position: 50%;
`;

export const DescriptionContainer = styled.div`
  position: relative;
`;

type DescriptionProps = {
  $isShowFullProfile: boolean;
};
export const Description = styled.div<DescriptionProps>`
  font-size: 14px;
  line-height: 140%;

  ${props => (props.$isShowFullProfile ? null : setLineClamp(3, "19.6px"))}

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    display: block;

    max-block-size: none;
  }

  a {
    display: initial;

    text-decoration: underline;
  }
`;

export const RawDescription = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0%;
  z-index: -1;

  font-size: 14px;
  line-height: 140%;

  visibility: hidden;
`;

export const ShowButton = styled.button`
  margin-block-start: 8px;

  color: #4585ff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  background: none;

  cursor: pointer;
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    display: none;
  }
`;
